import { useQuery } from "@tanstack/react-query";

import { CasinoConfigQueryKeys } from "./casinoConfigQueryKeys";
import { getCasinoConfig } from "@/api/casinoConfig";

export const useCasinoConfig = (options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: [CasinoConfigQueryKeys.CasinoConfig],
    enabled: options?.enabled ?? true,
    queryFn: ({ signal }) => {
      return getCasinoConfig({ signal });
    },
  });
};
